export const DEFAULT_ICON_SIZE = 24;
